import React from 'react';
import styled from 'styled-components';
// --------------------------------------------------------------------------------
import { String } from './String';
import { config } from '../index';

export interface CategoryComponentProps {
  /* Category title */
  title?: string;
  /* Category image url */
  url?: string;
  /* Category image border radius */
  borderRadius?: string;
  /* ListingComponent margin */
  margin?: string;
  /* ListingComponent padding */
  padding?: string;
  /* ListingComponent width */
  width?: string;
  /* ListingComponent height */
  height?: string;
  /* ListingComponent additional class props */
  className?: string;
  /* Category onClick handler */
  onClick?: (event?: React.MouseEvent) => void;
}

const StyledCategoryComponent = styled.div<CategoryComponentProps>`
  position: relative;
  cursor: pointer;
  overflow: hidden;
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border-radius: ${(props) => props.borderRadius};
  background: pink;
`;

const TitleWrapper = styled.div<CategoryComponentProps>`
  position: absolute;
  bottom: 0;
  left: 0;
`;

export const CategoryComponent: React.FC<CategoryComponentProps> = ({
  url,
  title,
  margin,
  padding,
  width = '270px',
  height = '325px',
  borderRadius = '10px',
  className,
  onClick,
  // additional props
  ...props
}) => {
  return (
    <StyledCategoryComponent
      margin={margin}
      padding={padding}
      borderRadius={borderRadius}
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      {...props} // any additional props that override the defaults
    >
      {url && <img src={url} alt={title || 'Category'} loading="lazy" />}
      {title && (
        <TitleWrapper>
          <String
            string={title}
            color={config.white}
            limit={1}
            margin="0 25px 10px 25px"
            fontSize="28px"
            fontWeight="bold"
          />
        </TitleWrapper>
      )}
    </StyledCategoryComponent>
  );
};
